import { FinancialProductionReportTemplate } from "../../Templates/FinancialProductionReportTemplate";

export const FinancialProductionReport = () => {
  return <FinancialProductionReportTemplate />;
};
